// eslint-disable-next-line angular/factory-name
angular.
module("digiexam.services").
factory("user", function userFactory($http) {
	"use strict";

	function User(data) {
		angular.extend(this, data || {});
	}

	User.verify = verify;
	User.get = get;
	User.query = query;

	function verify(userId, code) {
		return $http.get("/user/verify/" + userId + "/" + code).then(function success(response) {
			return response.data;
		});
	}

	function get(id) {
		return $http.get("/user/" + id).then(function success(response) {
			return new User(response.data);
		});
	}

	function query(queryParams) {
		var requestConfig = {
			url: "/user/query/",
			method: "GET",
			params: queryParams,
		};

		return $http(requestConfig).then(function success(response) {
			return response.data;
		});
	}

	return User;
});
